import { jsxs, jsx } from "react/jsx-runtime";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function SvgButtonAddDark(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      opacity: .5,
      clipPath: "url(#a)",
      stroke: "#646E7B",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: jsx("path", {
        d: "M18.333 10a8.333 8.333 0 1 0-16.667 0 8.333 8.333 0 0 0 16.667 0zM6.667 10h6.666M10 13.333V6.667"
      })
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "a",
        children: jsx("path", {
          fill: "#fff",
          transform: "rotate(-90 10 10)",
          d: "M0 0h20v20H0z"
        })
      })
    })]
  }));
}

function SvgButtonAdd(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666zm0-11.666v6.666M6.667 10h6.666",
      opacity: .5,
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgButtonCheckmark(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      opacity: .5,
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [jsx("path", {
        d: "M18.333 9.234V10a8.334 8.334 0 1 1-4.941-7.616"
      }), jsx("path", {
        d: "M18.333 3.333 10 11.675l-2.5-2.5"
      })]
    })]
  }));
}

function SvgButtonCopy(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M17.5 7.45a1.09 1.09 0 0 0-.05-.225V7.15a.893.893 0 0 0-.158-.233l-5-5a.892.892 0 0 0-.234-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H8.333a2.5 2.5 0 0 0-2.5 2.5V5H5a2.5 2.5 0 0 0-2.5 2.5v8.333a2.5 2.5 0 0 0 2.5 2.5h6.667a2.5 2.5 0 0 0 2.5-2.5V15H15a2.5 2.5 0 0 0 2.5-2.5V7.45zm-5-2.942 2.158 2.159h-1.325a.833.833 0 0 1-.833-.834V4.508zm0 11.325a.833.833 0 0 1-.833.834H5a.833.833 0 0 1-.833-.834V7.5A.833.833 0 0 1 5 6.667h.833V12.5a2.5 2.5 0 0 0 2.5 2.5H12.5v.833zm3.333-3.333a.834.834 0 0 1-.833.833H8.333A.833.833 0 0 1 7.5 12.5V4.167a.833.833 0 0 1 .833-.834h2.5v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5V12.5z",
      fill: "#7D8793"
    })]
  }));
}

function SvgButtonDelete(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M2.5 5h15M6.667 5V3.333a1.667 1.667 0 0 1 1.667-1.666h3.333a1.667 1.667 0 0 1 1.667 1.666V5m2.5 0v11.667a1.666 1.666 0 0 1-1.667 1.666H5.834a1.667 1.667 0 0 1-1.667-1.666V5h11.667zm-4.167 4.167v5m-3.334-5v5",
      stroke: "#7D8793",
      strokeWidth: 1.667,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgButtonEdit(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M10 16.667h7.5m-3.75-13.75a1.768 1.768 0 0 1 2.5 2.5L5.833 15.833l-3.333.834.833-3.334L13.75 2.917z",
      stroke: "#646E7B",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgButtonExport(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M17.5 13v3.333A1.666 1.666 0 0 1 15.833 18H4.167A1.667 1.667 0 0 1 2.5 16.333V13m11.666-5.833L10 3 5.833 7.167M10 3v10",
      stroke: "#9CA5B0",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgButtonRevert(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M11.536 18.221a.648.648 0 0 1-.758-.52.651.651 0 0 1 .52-.759l-.003-.02.004.02c.14-.025.28-.056.419-.09a.65.65 0 0 1 .788.474.65.65 0 0 1-.474.788c-.164.04-.33.077-.496.107zM16.91 6.548a.672.672 0 0 1 .873.375c.063.157.121.318.175.478l-1.276.423a7.043 7.043 0 0 0-.147-.402.672.672 0 0 1 .374-.874zm0 0 .007.02m-.008-.02.008.02m1.02.84a8.36 8.36 0 0 0-.174-.477.65.65 0 0 0-.846-.363m1.02.84-1.02-.84m1.02.84a.65.65 0 0 1-.413.822l.007.02-.007-.02m.413-.822-.413.822m0 0a.65.65 0 0 1-.58-.086l.58.086zm-4.044 8.998.013-.018a.649.649 0 0 1-.188-.207.65.65 0 0 1 .238-.888 7.08 7.08 0 0 0 .365-.226.65.65 0 0 1 .901.184.65.65 0 0 1-.184.901 7.97 7.97 0 0 1-.432.268.65.65 0 0 1-.7-.032l-.013.018zm0 0a.673.673 0 0 0 .724.032l-.308-1.389a6.13 6.13 0 0 1-.364.225.672.672 0 0 0-.052 1.132zm1.157-.236a.672.672 0 0 0 .19-.93l-.19.93z",
      fill: "#7D8793",
      stroke: "#55606C",
      strokeWidth: .043
    }), jsx("path", {
      d: "M18.376 9.7a.672.672 0 0 0-1.343.053c.005.142.007.286.003.427a.671.671 0 1 0 1.344.03 8.33 8.33 0 0 0-.004-.51zm-1.804 4.403a.672.672 0 0 0-.94.135 6.988 6.988 0 0 1-.268.334.672.672 0 0 0 1.024.871c.11-.129.216-.263.318-.399a.672.672 0 0 0-.134-.94zm.988-2.428a.672.672 0 0 0-.842.44 8.78 8.78 0 0 1-.14.404.672.672 0 0 0 1.255.479c.06-.159.116-.32.167-.481a.672.672 0 0 0-.44-.842zm-8.78 5.252a6.94 6.94 0 0 1-1.723-.548l-.019-.01a7.282 7.282 0 0 1-.382-.193l-.002-.001A7.02 7.02 0 0 1 4.291 5.986a6.983 6.983 0 0 1 1.724-1.715l.024-.016a7.024 7.024 0 0 1 7.873-.064l-.526.759c-.145.211-.056.365.2.342l2.28-.204a.376.376 0 0 0 .34-.492l-.612-2.206c-.069-.247-.244-.277-.39-.066l-.527.76A8.298 8.298 0 0 0 7.96 1.927l-.004.001-.024.007a8.286 8.286 0 0 0-4.595 3.08 7.924 7.924 0 0 0-.32.454L3 5.5a8.284 8.284 0 0 0-1.324 4.887v.017c.008.169.021.34.04.508 0 .01.003.021.004.032a8.293 8.293 0 0 0 2.41 5.005l.01.01.002.002a8.47 8.47 0 0 0 1.07.894 8.285 8.285 0 0 0 3.333 1.395.672.672 0 1 0 .237-1.323z",
      fill: "#7D8793"
    }), jsx("path", {
      d: "M9.612 4.595c-.3 0-.544.244-.544.544v5.417l4.954 2.56a.541.541 0 0 0 .732-.233.543.543 0 0 0-.233-.732l-4.366-2.258V5.14c0-.3-.243-.544-.543-.544z",
      fill: "#7D8793"
    })]
  }));
}

function SvgButtonShare(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M15 18.334a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM5 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm2.158-1.242 5.692 3.317M15 6.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-2.159-1.242L7.159 8.74",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgCollab(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 28,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 28,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("rect", {
      x: 8.02,
      y: 1,
      width: 18.72,
      height: 18.182,
      rx: 1.027,
      fill: "#fff",
      stroke: "#9CA5B0",
      strokeWidth: 2
    }), jsx("rect", {
      x: 4.51,
      y: 4.409,
      width: 18.72,
      height: 18.182,
      rx: 1.027,
      fill: "#fff",
      stroke: "#9CA5B0",
      strokeWidth: 2
    }), jsx("rect", {
      x: 1,
      y: 8,
      width: 18.72,
      height: 18.182,
      rx: 1.027,
      fill: "#fff",
      stroke: "#9CA5B0",
      strokeWidth: 2
    }), jsx("path", {
      d: "M16.21 16.38v1.42a.542.542 0 0 1-.549.533H11.64v3.906a.542.542 0 0 1-.549.533H9.63a.542.542 0 0 1-.549-.533v-3.906H5.058a.542.542 0 0 1-.548-.533v-1.42c0-.293.247-.533.548-.533H9.08v-3.906c0-.293.247-.533.549-.533h1.462c.302 0 .549.24.549.533v3.906h4.021c.302 0 .549.24.549.533z",
      fill: "#9CA5B0"
    })]
  }));
}

function SvgErrorCircle(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : undefined,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : undefined,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M12.654 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm3-13-6 6m0-6 6 6",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgGreenLight(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 14,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 14,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("circle", {
      cx: 7,
      cy: 7,
      r: 7,
      fill: "#57A886"
    })]
  }));
}

function SvgIconAdmin(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      fill: "#314551",
      fillOpacity: .5,
      children: [jsx("path", {
        d: "M8.05 8.927a3.95 3.95 0 1 1 7.9 0v.44a3.95 3.95 0 0 1-7.9 0v-.44z"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.555 19.16A11.8 11.8 0 0 1 .148 12C.148 5.454 5.454.148 12 .148S23.852 5.454 23.852 12a11.8 11.8 0 0 1-2.707 7.539A11.828 11.828 0 0 1 12 23.852c-3.855 0-7.28-1.841-9.445-4.692zm1.763.44c1.098-1.895 4.19-4.09 7.682-4.09s6.804 2.415 7.682 4.088c1.763-1.673 3.292-5.142 3.292-7.6 0-6.06-4.913-10.973-10.974-10.973C5.94 1.026 1.026 5.939 1.026 12c0 2.457 1.529 5.926 3.292 7.6z"
      })]
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .148,
        y: .148,
        width: 23.704,
        height: 25.185,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconDashboard(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 17",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 17,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      opacity: .4,
      filter: "url(#a)",
      children: jsx("path", {
        d: "M15.84.623C7.56-2.017 0 4.103 0 12.023c0 1.08.12 3.12.48 4.32 0 .24.24.48.48.48h21.96c.24 0 .48-.24.6-.48.24-1.2.48-3.24.48-4.32 0-5.16-3.24-9.84-8.16-11.4zM12 2.423c.72 0 1.2.48 1.2 1.2s-.48 1.2-1.2 1.2-1.2-.48-1.2-1.2.48-1.2 1.2-1.2zm-8.4 10.8c-.72 0-1.2-.48-1.2-1.2s.48-1.2 1.2-1.2 1.2.48 1.2 1.2-.48 1.2-1.2 1.2zm3.36-6.24c-.48.48-1.2.48-1.68 0s-.48-1.32-.12-1.8c.48-.48 1.2-.48 1.68 0s.48 1.32.12 1.8zm5.04 7.44c-1.32 0-2.52-1.2-2.16-2.4.36-1.2 2.16-4.8 2.16-4.8s1.8 3.6 2.16 4.8c.36 1.2-.84 2.4-2.16 2.4zm6.84-7.44c-.48.48-1.2.48-1.68 0a1.16 1.16 0 0 1 0-1.68c.48-.48 1.2-.48 1.68 0 .36.36.36 1.2 0 1.68zm1.56 6.24c-.72 0-1.2-.48-1.2-1.2s.48-1.2 1.2-1.2 1.2.48 1.2 1.2-.48 1.2-1.2 1.2z",
        fill: "#fff"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: 0,
        y: 0,
        width: 24,
        height: 18.304,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconHub(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 17",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 27,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 17,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.507.852a2.1 2.1 0 0 0-2.1 2.1v11.356c0 1.16.94 2.1 2.1 2.1h21.727a2.1 2.1 0 0 0 2.1-2.1V2.951a2.1 2.1 0 0 0-2.1-2.099H2.507zm.75 6.138a.54.54 0 1 0 0 1.08h20.738a.54.54 0 1 0 0-1.08H3.258zm-.54 2.782a.54.54 0 0 1 .54-.54H20.79a.54.54 0 0 1 0 1.08H3.258a.54.54 0 0 1-.54-.54zm18.255 3.488a.54.54 0 1 0 0 1.08h3.133a.54.54 0 0 0 0-1.08h-3.133zm-18.071.54a.54.54 0 0 1 .54-.54h3.133a.54.54 0 1 1 0 1.08H3.44a.54.54 0 0 1-.54-.54zM23.897.852h-9.373v3.144c0 .421.342.763.764.763h7.846a.763.763 0 0 0 .763-.763V.852z",
        fill: "#45CCDE"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .407,
        y: .852,
        width: 25.926,
        height: 15.926,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: .37
        }), jsx("feGaussianBlur", {
          stdDeviation: .37
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconInstantPay(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 19,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      filter: "url(#a)",
      children: jsx("path", {
        d: "M10.417 1 1 12.3h8.475l-.942 7.533 9.417-11.3H9.475L10.417 1z",
        stroke: "#316959",
        strokeWidth: 1.883,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .058,
        y: .058,
        width: 18.833,
        height: 22.198,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconPassporting(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 16,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M6.274 4.375c-.313.84-.49 1.902-.54 2.974H4.037a4.028 4.028 0 0 1 2.237-2.974zm-.54 4.275c.05 1.073.227 2.136.54 2.976A4.028 4.028 0 0 1 4.037 8.65h1.697zm1.303 0h1.927c-.035 1.04-.362 2.91-.964 3.361-.604-.456-.927-2.316-.963-3.36zm1.556-3.574c.2.636.327 1.426.37 2.273H7.038C7.07 6.311 7.397 4.44 8 3.99c.084.048.349.312.593 1.087zm1.673 3.574h1.697a4.028 4.028 0 0 1-2.237 2.976c.313-.84.49-1.903.54-2.975zm1.697-1.3h-1.697c-.05-1.073-.227-2.136-.54-2.975a4.028 4.028 0 0 1 2.237 2.974z",
      fill: "#DC5A54"
    }), jsx("path", {
      d: "M14 0H0v20h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-4 16.65H6v-1.3h4v1.3zm-1.964-3.333C.938 13.078.943 2.92 8.036 2.683c7.009.333 7.003 10.304 0 10.634z",
      fill: "#DC5A54"
    })]
  }));
}

function SvgIconRoster(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      children: jsx("path", {
        d: "M17.704.37H2.296A1.934 1.934 0 0 0 .37 2.298v15.407c0 1.058.867 1.926 1.926 1.926h15.408a1.933 1.933 0 0 0 1.926-1.926V2.297A1.932 1.932 0 0 0 17.704.37zM5.568 17.32h-2.95v-2.624h2.95v2.624zm0-3.505h-2.95v-2.623h2.95v2.623zM5.346 3.29a.817.817 0 1 1-.001-1.634.817.817 0 0 1 0 1.634zm4.159 14.03h-2.95v-2.624h2.95v2.624zm0-3.505h-2.95v-2.623h2.95v2.623zm0-3.502h-2.95V7.69h2.95v2.623zm-.322-7.841a.817.817 0 1 1 1.633 0 .817.817 0 0 1-1.633 0zm4.262 11.344h-2.95v-2.624h2.95v2.623zm0-3.503h-2.95V7.69h2.95v2.623zm.392-7.841a.817.817 0 1 1 1.634-.001.817.817 0 0 1-1.634 0zm3.546 11.344h-2.95v-2.624h2.95v2.623zm0-3.503h-2.95V7.69h2.95v2.623z",
        fill: "#FF9165"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .37,
        y: .371,
        width: 19.259,
        height: 19.63,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: .37
        }), jsx("feGaussianBlur", {
          stdDeviation: .37
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconSuperAdmin(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      filter: "url(#a)",
      fill: "#fff",
      children: [jsx("path", {
        opacity: .34,
        d: "M18.492 10.5c0-.388-.028-.777-.084-1.161l2.498-1.734-2.72-4.71-2.75 1.296a7.97 7.97 0 0 0-2.011-1.163L13.172 0H7.734L7.48 3.028a7.973 7.973 0 0 0-2.01 1.163L2.72 2.895 0 7.605 2.498 9.34a8.11 8.11 0 0 0 0 2.322L0 13.395l2.72 4.71 2.75-1.296a7.953 7.953 0 0 0 2.214 1.24v-2.705a5.593 5.593 0 0 1-1.93-1.838 5.56 5.56 0 0 1-.88-3.006 5.565 5.565 0 0 1 3.85-5.305l.806-.262v4.04l.923.74.923-.74v-4.04l.806.262a5.565 5.565 0 0 1 3.85 5.305 5.56 5.56 0 0 1-.88 3.006 5.591 5.591 0 0 1-1.93 1.838v2.705a7.95 7.95 0 0 0 2.214-1.24l2.75 1.296 2.72-4.71-2.498-1.734c.056-.384.084-.773.084-1.161z"
      }), jsx("path", {
        opacity: .7,
        d: "m11.991 14.586.348-.168a4.375 4.375 0 0 0 2.462-3.918c0-1.59-.854-3.018-2.195-3.78v2.845l-2.153 1.723L8.3 9.565V6.721A4.337 4.337 0 0 0 6.105 10.5c0 1.66.967 3.197 2.462 3.918l.348.168V21h3.076v-6.414z"
      })]
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: 0,
        y: 0,
        width: 20.906,
        height: 22.481,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: 1.481
        }), jsx("feGaussianBlur", {
          stdDeviation: 1.481
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgIconVms(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("g", {
      style: {
        mixBlendMode: "multiply"
      },
      filter: "url(#a)",
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.388 8.613c-.192 0-.378.021-.56.056C2.103 4.063 5.954.371 10.63.371c4.675 0 8.526 3.692 8.801 8.298a2.924 2.924 0 0 0-.56-.056H17.7c-.215 0-.419.044-.61.115-.242-3.339-3.06-6.014-6.46-6.014-3.401 0-6.219 2.675-6.46 6.014a1.739 1.739 0 0 0-.61-.115H2.387zm0 8.242h1.171a.586.586 0 0 0 .586-.586v-5.898a.586.586 0 0 0-.586-.586H2.387c-.97 0-1.757.787-1.757 1.758v3.554c0 .97.787 1.758 1.757 1.758zm16.484-7.07H17.7a.586.586 0 0 0-.586.586v7.07a.586.586 0 0 1-.586.586h-3.037a1.755 1.755 0 0 0-1.65-1.172H9.458A1.76 1.76 0 0 0 7.7 18.613a1.76 1.76 0 0 0 1.758 1.758h2.383c.763 0 1.407-.492 1.65-1.172h3.037a1.76 1.76 0 0 0 1.758-1.758v-.586h.586c.97 0 1.758-.787 1.758-1.758v-3.554c0-.971-.787-1.758-1.758-1.758z",
        fill: "#FFD24C"
      })
    }), jsx("defs", {
      children: jsxs("filter", {
        id: "a",
        x: .63,
        y: .371,
        width: 20,
        height: 20.37,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), jsx("feOffset", {
          dy: .37
        }), jsx("feGaussianBlur", {
          stdDeviation: .37
        }), jsx("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), jsx("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow"
        })]
      })
    })]
  }));
}

function SvgInfo(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM12 16v-4M12 8h.01",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgInputDate(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M19.778 22.905H4.222c-1.227 0-2.222-.98-2.222-2.19V5.38c0-1.21.995-2.19 2.222-2.19h2.222V1h2.223v2.19h6.666V1h2.223v2.19h2.222c1.227 0 2.222.981 2.222 2.191v15.333c0 1.21-.995 2.19-2.222 2.19zM4.222 9.762v10.952h15.556V9.762H4.222zm0-4.381v2.19h15.556v-2.19H4.222zm8.89 12.843a.3.3 0 0 1-.3.3h-1.623a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.622a.3.3 0 0 1 .3.3v1.59zm-4.445 0a.3.3 0 0 1-.3.3H6.744a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.623a.3.3 0 0 1 .3.3v1.59zm8.889-4.381a.3.3 0 0 1-.3.3h-1.623a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.623a.3.3 0 0 1 .3.3v1.59zm-4.445 0a.3.3 0 0 1-.3.3H11.19a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.622a.3.3 0 0 1 .3.3v1.59zm-4.444 0a.3.3 0 0 1-.3.3H6.744a.3.3 0 0 1-.3-.3v-1.59a.3.3 0 0 1 .3-.3h1.623a.3.3 0 0 1 .3.3v1.59z",
      fill: "#9CA5B0"
    })]
  }));
}

function SvgInputTimeEnd(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M11 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-14a1 1 0 0 0-1 1v3.27l-1.1-.64a1.003 1.003 0 1 0-1 1.74l2.6 1.5h.16A1 1 0 0 0 11 13a.998.998 0 0 0 .34-.07h.08a.92.92 0 0 0 .28-.19 1.57 1.57 0 0 0 .15-.19v-.06c.024-.058.045-.119.06-.18a1.42 1.42 0 0 0 0-.2V7A1 1 0 0 0 11 6z",
      fill: "#7D8793"
    })]
  }));
}

function SvgInputTime(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M11 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm3.1-7.37L12 11.42V7a1 1 0 0 0-2 0v5.12a.65.65 0 0 0 .05.2c.02.06.047.116.08.17.027.057.06.11.1.16l.16.13.09.09 2.6 1.5a1 1 0 0 0 .5.13 1 1 0 0 0 .5-1.87h.02z",
      fill: "#7D8793"
    })]
  }));
}

function SvgLinkedIn(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      opacity: .5,
      d: "M18.41 0H1.47A1.45 1.45 0 0 0 0 1.43v17.14A1.45 1.45 0 0 0 1.47 20h16.94a1.45 1.45 0 0 0 1.47-1.43V1.43A1.45 1.45 0 0 0 18.41 0ZM6.03 16.74h-3v-9h3v9ZM4.53 6.48a1.56 1.56 0 0 1 0-3.12 1.57 1.57 0 1 1 0 3.12Zm12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0 0 10.79 11a1.999 1.999 0 0 0-.1.73v5h-3v-9h3V9a3 3 0 0 1 2.71-1.5c2 0 3.45 1.29 3.45 4.06v5.18Z",
      fill: "#fff"
    })]
  }));
}

function SvgPen(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M20 5.24a1.002 1.002 0 0 0-.29-.71L15.47.29a1.001 1.001 0 0 0-.71-.29 1 1 0 0 0-.71.29l-2.83 2.83L.29 14.05a1.001 1.001 0 0 0-.29.71V19a1 1 0 0 0 1 1h4.24a1.001 1.001 0 0 0 .76-.29L16.87 8.78 19.71 6a1.19 1.19 0 0 0 .22-.33c.01-.08.01-.16 0-.24a.697.697 0 0 0 0-.14l.07-.05ZM4.83 18H2v-2.83l9.93-9.93 2.83 2.83L4.83 18ZM16.17 6.66l-2.83-2.83 1.42-1.41 2.82 2.82-1.41 1.42Z",
      fill: "#7D8793"
    })]
  }));
}

function SvgPie(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M21.21 15.89A10 10 0 1 1 8 2.83",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M22 12A10 10 0 0 0 12 2v10h10Z",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgRedLight(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 14,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 14,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("circle", {
      cx: 7,
      cy: 7,
      r: 7,
      fill: "#BD2D2E"
    })]
  }));
}

function SvgSearchLoupe(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M20.71 19.29 17 15.61A9 9 0 1 0 15.61 17l3.68 3.68a.999.999 0 0 0 1.42 0 1 1 0 0 0 0-1.39zM10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14z",
      fill: "#9CA5B0"
    })]
  }));
}

function SvgSelectChevron(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 8",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 14,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 8,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "m1 1 6 6 6-6",
      stroke: "#9CA5B0",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgSettings(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a1.998 1.998 0 0 1 0 2.83 1.998 1.998 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a1.998 1.998 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 3.417 1.415 2 2 0 0 1-.587 1.415l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1v0Z",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
}

function SvgToggle(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 24,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      d: "M16 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM16 5H8a7 7 0 0 0 0 14h8a7 7 0 1 0 0-14Zm0 12H8A5 5 0 0 1 8 7h8a5 5 0 1 1 0 10Z",
      fill: "#7D8793"
    })]
  }));
}

function SvgTwitter(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 17,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsx("path", {
      opacity: .5,
      d: "M20 1.95a8.49 8.49 0 0 1-2.36.64A4.13 4.13 0 0 0 19.45.32a8.21 8.21 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74A11.64 11.64 0 0 1 1.39.77a4.16 4.16 0 0 0-.55 2.07 4.09 4.09 0 0 0 1.82 3.41A4.05 4.05 0 0 1 .8 5.74v.05a4.1 4.1 0 0 0 3.3 4 3.93 3.93 0 0 1-1.1.17 4.9 4.9 0 0 1-.77-.07 4.11 4.11 0 0 0 3.83 2.84A8.22 8.22 0 0 1 0 14.43a11.57 11.57 0 0 0 6.29 1.85A11.59 11.59 0 0 0 18 4.6v-.53a8.43 8.43 0 0 0 2-2.12Z",
      fill: "#fff"
    })]
  }));
}

function SvgViewEye(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 21,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      opacity: .5,
      clipPath: "url(#a)",
      stroke: "#7D8793",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [jsx("path", {
        d: "M1.333 10S4.668 3.333 10.5 3.333c5.834 0 9.167 6.667 9.167 6.667s-3.334 6.667-9.167 6.667S1.334 10 1.334 10z"
      }), jsx("path", {
        d: "M10.5 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "a",
        children: jsx("path", {
          fill: "#fff",
          transform: "translate(.5)",
          d: "M0 0h20v20H0z"
        })
      })
    })]
  }));
}

function SvgWhiteCheckmark(_param) {
  var title = _param.title,
      titleId = _param.titleId,
      props = _objectWithoutProperties(_param, ["title", "titleId"]);

  return jsxs("svg", _objectSpreadProps(_objectSpread({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    height: (props === null || props === void 0 ? void 0 : props.size) ? props.size : 20,
    "aria-labelledby": titleId
  }, props), {
    children: [title ? jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxs("g", {
      opacity: .5,
      stroke: "#fff",
      children: [jsx("path", {
        d: "M18.334 9.233V10a8.334 8.334 0 1 1-4.942-7.617"
      }), jsx("path", {
        d: "M18.333 3.333 10 11.675l-2.5-2.5"
      })]
    })]
  }));
}

export { SvgButtonAdd as ButtonAdd, SvgButtonAddDark as ButtonAddDark, SvgButtonCheckmark as ButtonCheckmark, SvgButtonCopy as ButtonCopy, SvgButtonDelete as ButtonDelete, SvgButtonEdit as ButtonEdit, SvgButtonExport as ButtonExport, SvgButtonRevert as ButtonRevert, SvgButtonShare as ButtonShare, SvgCollab as Collab, SvgErrorCircle as ErrorCircle, SvgGreenLight as GreenLight, SvgIconAdmin as IconAdmin, SvgIconDashboard as IconDashboard, SvgIconHub as IconHub, SvgIconInstantPay as IconInstantPay, SvgIconPassporting as IconPassporting, SvgIconRoster as IconRoster, SvgIconSuperAdmin as IconSuperAdmin, SvgIconVms as IconVms, SvgInfo as Info, SvgInputDate as InputDate, SvgInputTime as InputTime, SvgInputTimeEnd as InputTimeEnd, SvgLinkedIn as LinkedIn, SvgPen as Pen, SvgPie as Pie, SvgRedLight as RedLight, SvgSearchLoupe as SearchLoupe, SvgSelectChevron as SelectChevron, SvgSettings as Settings, SvgToggle as Toggle, SvgTwitter as Twitter, SvgViewEye as ViewEye, SvgWhiteCheckmark as WhiteCheckmark };